import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { ActDomainManagementVM } from 'civil-status/view-models/act-domain-managment-list';
export const authsObj = Object.freeze({
  read: [CivilStatusAuthorizations.AnscDominioQuery],
  create: [CivilStatusAuthorizations.AnscDominioInsert],
  edit: [CivilStatusAuthorizations.AnscDominioUpdate],
  delete: [CivilStatusAuthorizations.AnscDominioDelete],
});

export const validationSchemaDomainManagementFilters = yup.object({
  domainType: yup.string().nullable().notRequired(),
  domainName: yup.string().nullable().notRequired(),
});

export const headCells: HeadCell<ActDomainManagementVM, keyof ActDomainManagementVM>[] = [
  {
    id: 'domainType',
    label: 'Tipo dominio',
  },
  {
    id: 'domainName',
    label: 'Nome dominio',
  },
  {
    id: 'action',
    label: '',
  },
];
